import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

const Signature = ({ data }) => {
  const completedOn = data["CompletedOn"] || {};
  const completedBy = data["CompletedBy"] || {};

  return (
    <table className="signature">
      <tbody>
        <tr>
          <td>Declared in SINGAPORE on: </td>
          <td>
            Day:{" "}
            <span id="RO_CompletedOnDay">
              {completedOn.fieldValue && moment(completedOn).format("D")}
            </span>
          </td>
          <td>
            Month:{" "}
            <span id="RO_CompletedOnMonth">
              {completedOn.fieldValue && moment(completedOn).format("MMM")}
            </span>
          </td>
          <td>
            Year:{" "}
            <span id="RO_CompletedOnYear">
              {completedOn.fieldValue && moment(completedOn).format("YYYY")}
            </span>
          </td>
        </tr>
        <tr />
        <tr className="signature-info">
          <td className="text--center" id="RO_CompletedByName">
            {completedBy.fieldValue}
          </td>
          <td colSpan="3" />
        </tr>

        <tr />
        <tr>
          <td className="divider" />
          <td className="divider" colSpan="3" />
        </tr>

        <tr />
        <tr>
          <td className="text--center">NAME &amp; SIGNATURE OF EMPLOYEE</td>
          <td colSpan="3" className="text--center">
            SIGNATURE OF SPOUSE
          </td>
        </tr>
      </tbody>
    </table>
  );
};

Signature.propTypes = {
  data: PropTypes.object,
};

export default Signature;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/Signature.jsx